
import "react-datepicker/dist/react-datepicker.css";
import { Cookies } from 'react-cookie';
import { useEffect, useState } from 'react';
import { BindReportGrid, exportToExcel, setFocus, setTitle } from "../Common/Common";
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { getCommonData } from '../Common/CommanServices';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { useNavigate } from "react-router-dom";
import Loader from "../Layout/Loader";
const PendingCollectReport = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode');
    const SalesPersonName = cookies.get('userName');
    const SalesPersonCode = cookies.get('salesPersonCode');
    const WarehouseName = cookies.get('warehouseName');
    const WarehouseCode = cookies.get('warehouseCode')
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false)
    const [SalesPersonPre, setSalesPersonPre] = useState('')
    const [customerData, setCustomerData] = useState([]);
    const [salesPerson, setSalesPerson] = useState([]);
    const [EmptyItemOption, setEmptyItemOption] = useState([]);
    const [WareHouseData, setWareHouseData] = useState([]);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [MenuText, setMenuText] = useState("Pending Collection Report");
    const [tableData, setTableData] = useState({
        totalRecord: 0,
        gridData: [{
        }]
    })

    const [FilterData, setFilterData] = useState({
        PageIndex: "1",
        Customer: "",
        SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
        Item: "",
        WareHouse: WarehouseCode ? WarehouseCode + ' : ' + WarehouseName : "",
    });

    useEffect(() => {
        setTitle('PendingCollectionReport', setOpen);
        setFocus('txtCustomer');
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, [])

    //useEffect(() => {
    //    getPendingCollectionData();
    //}, [FilterData.PageIndex, isUpdate]);

    const getPendingCollectionData = (Type = 'S', PI = FilterData?.PageIndex || "1") => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...FilterData, Type: Type, Token, LoginUserCode: loginCodeString, PageIndex: `${PI}`
        }
        setIsLoading(true)

        post(`${API_SERVER}/api/Report/ShowExPendingCollectionReport`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {              
                if (Type === 'S') {
                    setTableData({
                        ...res
                    });
                }
                else {
                    if (Array.isArray(res.Data)) {
                        exportToExcel(res.Data, 'PendingCollectionReport');
                       
                    }
                }
            }
            else if (res.Status === "EXPIRED") {
                navigate('/Login')
            }            
            else if (res.Message !== "") {
                AlertBox(res.Status, res.Message, res.Focus);
                setTableData({
                    
                });

            }
            setIsLoading(false)
        })
    }

    const handleChange1 = (event, value) => {
        getPendingCollectionData("S", value);
        console.log(value)
    };

    const handleClearData = () => {
        setFilterData(
            {
                PageIndex: "1",
                Customer: "",
                SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
                Item: "",
                WareHouse: WarehouseCode ? WarehouseCode + ' : ' + WarehouseName : "",
            }
        );

        setTableData({});
        setFocus('txtCustomer');
        setIsUpdate(!isUpdate)
    }

    const searchHandle = async () => {
        setFilterData({
            ...FilterData,
            PageIndex: "1",
        })
        getPendingCollectionData();
    }

    const handleDownloadExcel = async () => {
        getPendingCollectionData('E');
    }

    const getSalesPerson = () => {
        setSalesPerson([]);
        let temp = {
            Type: "GetSalesPerson",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let salesPersonData = res.autoCompleteData || [];
                setSalesPerson(salesPersonData);
            } else {
                setSalesPerson([]);
            }
        });
    };

    const HandleChange = (prop, value) => {
        setFilterData(FilterData => ({ ...FilterData, [prop]: value }));
    }

    const getCustomer = () => {
        setCustomerData([])
        let temp = {
            Type: "GetCustomer",
            Prefix: "",
            ContextKey: SalesPersonPre.split(':')[0].trim(),
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token: Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let CustomerDatalist = res.autoCompleteData || [];
                setCustomerData(CustomerDatalist);
            } else {
                setCustomerData([]);
            }
        });
    }
    const getEmpties = () => {
        setEmptyItemOption([])
        let temp = {
            Type: "GetEmptiesItemNo",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token: Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let emptiesdatalist = res.autoCompleteData || [];
                setEmptyItemOption(emptiesdatalist);
            } else {
                setEmptyItemOption([]);
            }
        });
    }
    const getWareHouse = () => {
        setWareHouseData([])
        let temp = {
            Type: "GetWareHouse",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let warehouseData = res.autoCompleteData || [];
                setWareHouseData(warehouseData);
            } else {
                console.error("Error fetching WareHouse data:", res.message);
                setWareHouseData([]);
            }
        });
    }
    let EmptiesItemArr = []
    for (let i = 0; i < EmptyItemOption.length; i++) {
        let mydata = EmptyItemOption[i]?.values
        EmptiesItemArr.push(mydata)
    };

    let SalesPersonArr = []
    for (let i = 0; i < salesPerson.length; i++) {
        let mydata = salesPerson[i]?.values
        SalesPersonArr.push(mydata)
    };

    let CustomerArr = []
    for (let i = 0; i < customerData.length; i++) {
        let mydata = customerData[i]?.values
        CustomerArr.push(mydata)
    };
    let WareHouseArr = []
    for (let i = 0; i < WareHouseData.length; i++) {
        let mydata = WareHouseData[i]?.values
        WareHouseArr.push(mydata)
    };
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtWareHouse") };
                                                }}
                                                label='Customer'
                                                placeholder="Customer "
                                                maxLength='50'
                                                options={CustomerArr}
                                                id='txtCustomer'
                                                required={false}
                                                ignore_common={true}
                                                onFocus={() => getCustomer()}
                                                inputValue={FilterData.Customer ? FilterData.Customer : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('Customer', newInputValue)

                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtSalesPerson") };
                                                }}
                                                label='Ware House'
                                                placeholder="Ware House"
                                                maxLength='50'
                                                options={WareHouseArr}
                                                disabled={WarehouseCode ? true : false}
                                                id='txtWareHouse'
                                                required={false}
                                                ignore_common={true}
                                                onFocus={() => getWareHouse()}
                                                inputValue={FilterData.WareHouse ? FilterData.WareHouse : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('WareHouse', newInputValue)
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtEmptiesItem") };
                                                }}
                                                disabled={SalesPersonCode ? true : false}
                                                label='Sales Person'
                                                placeholder="Sales Person"
                                                maxLength='50'
                                                options={SalesPersonArr}
                                                id='txtSalesPerson'
                                                required={false}
                                                ignore_common={true}
                                                onFocus={() => getSalesPerson()}
                                                inputValue={FilterData.SalesPerson ? FilterData.SalesPerson : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('SalesPerson', newInputValue)
                                                    setSalesPersonPre(newInputValue)
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("btnSearch") };
                                                }}
                                               
                                                label='Empties Item'
                                                placeholder="Empties Item"
                                                maxLength='50'
                                                options={EmptiesItemArr}
                                                id='txtEmptiesItem'
                                                required={false}
                                                ignore_common={true}
                                                onFocus={() => getEmpties()}
                                                inputValue={FilterData.Item ? FilterData.Item : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('Item', newInputValue)
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            <button className="button save-btn" id='btnSearch' onClick={searchHandle}>
                                                <i className="bi bi-search" /> Search
                                            </button>
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClearData} >
                                                <i className="bi bi-arrow-clockwise"  /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindReportGrid tableData={tableData} setFilterData={setFilterData} filterData={FilterData} currentPageNo={currentPageNo} handleChange1={handleChange1} />
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
        </main>
    )
}
export default PendingCollectReport